import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import 'bootstrap/js/dist/dropdown.js'
import $ from 'jquery';

const MapSwitchControl = ({
    mapChanged,
    mapType
}) => {

    /*
    $('.dropdown').on('show.bs.dropdown', function () {
        $('body').append($('.dropdown').css({
            position: 'absolute',
            left: $('.dropdown').offset().left - 4,
            top: $('.dropdown').offset().top
        }).detach());
    });

    $('.dropdown').on('hidden.bs.dropdown', function () {
        $('.map-controls').append($('.dropdown').removeAttr('style'));
    });
    */

    function selectMap(e) {
        var mapTypeObj;
        switch (e.target.text) {
            case "Hybrid":
                mapTypeObj = { type: "OSM", variant: "OSM" };
                break;

            //case "Road":
                //mapTypeObj = { type: "GOOGLE", variant: "roadmap" };
                //break;

            case "Satellite":
                mapTypeObj = { type: "GOOGLE", variant: "satellite" };
                break;
            case "Ordnance Survey":
                mapTypeObj = { type: "BING", variant: "OS" };
                break;
        }
        mapChanged(mapTypeObj);
    }

    return (
        <React.Fragment>
            <div className="dropdown map-switch float-left ml-1">
                <button className="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="fas fa-map-marked-alt" /> Select Map
                </button>
                <div className="dropdown-menu " aria-labelledby="dropdownMenuButton">
                    <a className={ mapType === "OSM" ? "dropdown-item active" : "dropdown-item" } onClick={selectMap}>Hybrid</a>
                    <a className={ mapType === "satellite" ? "dropdown-item active" : "dropdown-item"}onClick={selectMap}>Satellite</a>
                    <a className={ mapType === "OS" ? "dropdown-item active" : "dropdown-item"} onClick={selectMap}>Ordnance Survey</a>
                </div>
            </div>
        </React.Fragment>
    );
}

/*<a className={ mapType === "roadmap" ? "dropdown-item active" : "dropdown-item"} onClick={selectMap}>Road</a>*/

MapSwitchControl.propTypes = {
    mapChanged: PropTypes.func.isRequired,
    mapType: PropTypes.string
}

export default MapSwitchControl;


// WEBPACK FOOTER //
// ./src/components/routes/MapSwitchControl.js